export default __webpack_public_path__ + "static/media/timebars.501f1814.svg";